declare global {
  interface Window {
    dataLayer: any;
  }
}
const gformDatalayer = () => {
  const gravityForms = document.querySelectorAll('.datalayer-contact');

  gravityForms.forEach((form) => {
    const submitButton = form.querySelector('.gform_submit');
    const email : HTMLInputElement = form.querySelector('input[type="email"]');
    if (submitButton) {
      submitButton.addEventListener('click', () => {
        // Ensure dataLayer exists
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'form_submission',
          email: email ? email.value : '',
        });
      });
    }
  });
};

export default gformDatalayer;
